import { Placeholder } from "semantic-ui-react";

export const LR_SERIES = {
    titles : {
        add : "Create LR Series",
        table_heading : "LR SERIES"
    },
    table_headers : {
        prefix :"Series Prefix",
        special_charecter : "Separator",
        date_format : "Date Format",
        lr_start : "LR Starting From",
        lr_end : "LR Ending In",
        series_type : "Series Type"
    },
    buttons : {
        add : "Add",
        delete : "Delete",
        cancel :"Cancel",
        submit :"Submit"
    },
    fields: {
        prefix :{
            title : "Series Prefix",
            placeholder : "Enter Series Prefix"
        },
        date_format : {
            title : "Date Format",
            year :"Year",
            month : "Month"
        },
        special_charecter : {
            title : "Separator",
            placeholder : "Enter Separator Charecter"
        },
        series_type : {
            title :"Series Type",
            placeholder : "Select Series Type"
        },
        lr_start : {
            title : "LR Starting From",
            placeholder : "Enter LR Starting Number"
        },
        lr_end : {
            title : "LR Ending In",
            placeholder : "Enter LR Ending Number"
        },
        lr_sample : {
            title : "LR Number Sample",
            placeholder :"LR Number Sample"
        },
        note : "Note : Please refer LR Number Sample as an example , LR will be starting from this."
    }
} 